import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Tippy from '@tippyjs/react';
import '../../../tippy.js/dist/tippy.css';

const styles = {
  gauge: (props) => ({
    display: 'flex',
    position: 'relative',
    borderRadius: '4px',
    // marginLeft: props.reverse ? '0' : '27px',
    // marginRight: props.reverse ? '27px' : '0',
    width: props.gaugew,
    height: props.gaugeh,
    backgroundColor: props.winMatchup ? '#fff' : '#ccc',
    cursor: 'pointer',
  }),
  team1chance: (props) => ({
    backgroundColor: '#62AD1D',
    width: props.matchup ? `${100 * props.matchup.chances[0]}%` : 0,
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',

  }),
  drawChance: (props) => ({
    backgroundColor: '#d2d2d2',
    width: props.matchup ? `${100 - ((100 * props.matchup.chances[0]) + (100 * props.matchup.chances[1]))}%` : 0,
    // borderTopLeftRadius: '10px',
    // borderBottomLeftRadius: '10px',
  }),
  team2chance: (props) => ({
    backgroundColor: '#F9981D',
    width: props.matchup ? `${100 * props.matchup.chances[1]}%` : 0,
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
  }),
  tick: (props) => ({
    left: props.tick,
    position: 'absolute',
    width: '1px',
    height: '15px',
    top: '-2px',
    backgroundColor: props.tickcolor,
    border: props.tickborder,
    opacity: '0.5',
  }),
  team1chancetext: (props) => ({
    left: props.reverse ? '10px' : '-20px',
  }),
  team2chancetext: (props) => ({
    left: props.reverse ? '-10px' : '20px',
  }),
  gaugecontainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
};

const Gauge = ({
  classes, style, teamA, teamB, matchup, noMoreTxt,
}) => (
  <div className={classes.gaugeContainer}>
    {
        matchup ? (
          <Tippy content={(
            <div style={{ padding: '5px' }}>
              <div>
                {teamA}
                {' '}
                {(100 * matchup.chances[0]).toPrecision(2)}
                % win
              </div>
              <div>
                {(100 - ((100 * matchup.chances[0]) + (100 * matchup.chances[1]))).toPrecision(2)}
                % draw
              </div>
              <div>
                {teamB}
                {' '}
                {(100 * matchup.chances[1]).toPrecision(2)}
                % win
              </div>
              {noMoreTxt && <div style={{ marginTop: '5px', color: '#dedede' }}>Click for more stats.</div>}
            </div>
          )}
          >
            <div className={classes.gauge} height={classes.gaugeh} width={classes.gaugew} style={style}>
              <div className={classes.team1chance} />
              <div className={classes.drawChance} />
              <div className={classes.team2chance} />
              <div className={classes.tick} />
            </div>
          </Tippy>
        )
          : (
            <div className={classes.gauge} height={classes.gaugeh} width={classes.gaugew} style={style}>
              <div className={classes.team1chance} />
              <div className={classes.drawChance} />
              <div className={classes.team2chance} />
              <div className={classes.tick} />
            </div>
          )
      }
  </div>
);

Gauge.propTypes = {
  classes: PropTypes.object.isRequired,
  gaugew: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  gaugeh: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  tick: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  tickcolor: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  tickborder: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  teamA: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  teamB: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  reverse: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  textvisible: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  style: PropTypes.object,
  matchup: PropTypes.object,
  noMoreTxt: PropTypes.bool,
};

Gauge.defaultProps = {
  // matchup: null,
  reverse: false,
  gaugeh: '6px',
  tickcolor: '#fff',
  tickborder: '0px',
  teamA: '',
  teamB: '',
  textvisible: false,
  style: {},
  noMoreTxt: false,
  matchup: null,
};

export default injectSheet(styles)(Gauge);
